import { useMemo, useState } from 'react';
import { GAME_DEFINITIONS, type GameDeck } from './gameComponents';
import './games.css';

type Filter = 'all' | GameDeck;

const FILTERS: Array<{ id: Filter; label: string; icon: string }> = [
  { id: 'all', label: 'Alle Übungen', icon: '✨' },
  { id: 'bs', label: 'Betriebssysteme', icon: '🖥️' },
  { id: 'sec', label: 'Informationssicherheit', icon: '🔐' },
  { id: 'db', label: 'Datenbanken', icon: '🗄️' },
  { id: 'net', label: 'Netze & Verteilte Sys.', icon: '🌐' },
];

export function GamesView() {
  const [filter, setFilter] = useState<Filter>('all');
  const [activeId, setActiveId] = useState<string | null>(null);
  const visibleGames = useMemo(
    () => filter === 'all' ? GAME_DEFINITIONS : GAME_DEFINITIONS.filter((game) => game.deck === filter),
    [filter],
  );
  const activeGame = activeId ? GAME_DEFINITIONS.find((game) => game.id === activeId) ?? null : null;
  const ActiveComponent = activeGame?.Component;

  return (
    <section className="view active games-view-react">
      <header className="page-head games-hero">
        <div>
          <p className="eyebrow">Interaktive Klausurübungen</p>
          <h1>{activeGame ? activeGame.title : 'Übungen'}</h1>
          <p className="muted">
            {activeGame
              ? `${activeGame.subtitle} · ${activeGame.tag}`
              : 'Jedes Mini-Game ist jetzt als eigenes React-Component gekapselt und kann separat weiter modernisiert werden.'}
          </p>
        </div>
        {activeGame && <button className="btn-ghost games-back" onClick={() => setActiveId(null)}>← Zurück zur Übersicht</button>}
      </header>

      {!activeGame && (
        <>
          <div className="games-filter modern" role="tablist" aria-label="Übungen filtern">
            {FILTERS.map((item) => {
              const count = item.id === 'all' ? GAME_DEFINITIONS.length : GAME_DEFINITIONS.filter((game) => game.deck === item.id).length;
              return (
                <button
                  key={item.id}
                  type="button"
                  className={`games-filter-chip ${filter === item.id ? 'active' : ''}`}
                  role="tab"
                  aria-selected={filter === item.id}
                  onClick={() => setFilter(item.id)}
                >
                  <span>{item.icon}</span>{item.label}<span className="games-filter-count">{count}</span>
                </button>
              );
            })}
          </div>

          <div className="games-cards modern-grid">
            {visibleGames.map((game) => (
              <button key={game.id} className="game-card modern-card" onClick={() => setActiveId(game.id)}>
                <div className="game-card-ico">{game.icon}</div>
                <div className="game-card-body">
                  <div className="game-card-kicker">{game.deck === 'bs' ? 'Betriebssysteme' : game.deck === 'sec' ? 'Informationssicherheit' : game.deck === 'db' ? 'Datenbanken' : 'Netze & Verteilte Systeme'}</div>
                  <div className="game-card-title">{game.title}</div>
                  <div className="game-card-sub">{game.subtitle}</div>
                  <div className="game-card-tag">{game.tag}</div>
                </div>
                <span className="game-card-arrow">→</span>
              </button>
            ))}
          </div>
        </>
      )}

      {activeGame && ActiveComponent && (
        <div className="game-stage react-stage">
          <div className="game-header react-game-header">
            <div className="game-header-ico">{activeGame.icon}</div>
            <div>
              <h2 className="game-header-title">{activeGame.title}</h2>
              <div className="game-header-sub">{activeGame.subtitle} · <span className="muted">{activeGame.tag}</span></div>
            </div>
          </div>
          <ActiveComponent />
        </div>
      )}
    </section>
  );
}
